/**
 * Strips <system-reminder> tags and their content from text
 * @param text - The text to process
 * @returns The text with system-reminder tags and content removed
 */
export function stripSystemReminders(text: string): string {
  if (!text) return text;
  
  // Regular expression to match <system-reminder> tags and their content
  // Uses non-greedy matching and handles multiline content
  const systemReminderRegex = /<system-reminder>[\s\S]*?<\/system-reminder>/gi;
  
  return text.replace(systemReminderRegex, '').trim();
}